import { render } from "./CreateStockOptions.vue?vue&type=template&id=e57bae5a&scoped=true"
import script from "./CreateStockOptions.vue?vue&type=script&lang=js"
export * from "./CreateStockOptions.vue?vue&type=script&lang=js"

import "./CreateStockOptions.vue?vue&type=style&index=0&id=e57bae5a&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e57bae5a"]])

export default __exports__